{
  "nl": {
    "task": {
      "actions": {
        "create": "Taak",
        "create_and_send": "Aanmaken en versturen",
        "delete": "Taak verwijderen",
        "keep_as_draft": "Als concept houden",
        "open_in_project": "Taak openen in project",
        "remove_from_unit": "Taak uit deze unit verwijderen",
        "save_as_draft": "Opslaan als concept",
        "update": "Taak bewerken"
      },
      "attributes": {
        "assignments_count": "Toewijzingen",
        "category": "Manier van afronden",
        "created_at": "Aangemaakt",
        "description": "Beschrijving",
        "phase": "Fase",
        "title": "Titel"
      },
      "categories": {
        "confirmation": "Bevestiging",
        "upload": "Document uploaden"
      },
      "categories_info": {
        "confirmation": "De toegewezene vinkt het af wanneer het klaar is.",
        "upload": "De toegewezene moet een bestand uploaden om af te ronden."
      },
      "confirm": {
        "delete_accept": "Overal verwijderen",
        "delete_body": "Dit verwijdert {count} taak over {units}, ook als ze al afgerond is. | Dit verwijdert alle {count} taken over {units}, ook de al afgeronde.",
        "delete_body_empty": "Dit verwijdert de taak.",
        "delete_body_project": "Dit verwijdert de taak en haar toegewezene. | Dit verwijdert de taak en alle {count} toegewezenen.",
        "delete_cancel": "Taak behouden",
        "delete_header": "Verwijder “{title}”?",
        "delete_silent": "Niemand krijgt een melding, en meldingen die al verstuurd zijn worden niet ingetrokken.",
        "publish_body": "We maken {tasks} over {units} en versturen ze naar hun toegewezenen. Elke taak krijgt de status Open tot ze afgerond is.",
        "publish_body_project": "We maken {tasks} in dit project en versturen ze naar hun toegewezenen. Elke taak krijgt de status Open tot ze afgerond is.",
        "publish_header": "Deze taak aanmaken en versturen?",
        "publish_info": "Toegewezenen krijgen meteen een e-mail. Sla op als concept als je nog niet klaar bent om te versturen.",
        "remove_from_unit_accept": "Uit unit verwijderen",
        "remove_from_unit_body": "Dit verwijdert alle toegewezenen van deze taak in deze unit. De taak en haar andere units blijven ongemoeid.",
        "remove_from_unit_customers": "Klanten van deze unit zien ze niet meer in hun portaal.",
        "remove_from_unit_header": "Verwijder “{title}” uit deze unit?"
      },
      "deep_link": {
        "show_all": "Toon alle taken",
        "single": "Je bekijkt één taak."
      },
      "empty": {
        "filtered_description": "Niets gevonden met de filters die je koos. Wis ze om alle taken te zien.",
        "filtered_description_project": "Niets gevonden met de filters die je koos. Wis ze om alle taken in dit project te zien.",
        "filtered_title": "Geen taken passen bij je filters",
        "none_description": "Maak een taak en wijs ze toe aan je team of aan de klanten van een of meer units. Ze verschijnt hier zodra je ze verstuurt.",
        "none_description_sup": "Maak een taak en wijs ze toe aan je team of aan je klanten. Ze verschijnt hier zodra je ze verstuurt.",
        "none_title": "Nog geen taken"
      },
      "filters": {
        "phase_none": "Geen fase",
        "search": "Taak zoeken"
      },
      "form": {
        "category_subtitle": "Bepaal hoe de toegewezene de taak als afgerond moet markeren",
        "category_title": "Hoe wordt het afgerond?",
        "description_help": "Zichtbaar voor iedereen die deze taak krijgt.",
        "description_placeholder": "Voeg details of instructies toe",
        "edit_info_assignments": "Toegewezenen, units en deadlines beheer je per toegewezene in de takenlijst.",
        "edit_info_assignments_project": "Toegewezenen en deadlines beheer je per toegewezene in de takenlijst.",
        "edit_info_fields": "Titel en beschrijving pas je hier aan.",
        "edit_info_fields_phase": "Titel, beschrijving en fase pas je hier aan.",
        "heading_create": "Nieuwe taak",
        "heading_update": "Taak aanpassen",
        "phase_help_update": "Elke unit die de nieuwe fase bereikt heeft, of er eerder al voorbij is, ziet deze taak meteen. Units die er nog niet zijn, zien ze zodra ze er komen.",
        "phase_help_update_project": "Heeft dit project de nieuwe fase bereikt, of is het er eerder al voorbij, dan zien de toegewezenen deze taak meteen. Anders zien ze hem zodra het project er komt.",
        "scope_headline": "{count} taak wordt aangemaakt en verstuurd | {count} taken worden aangemaakt en verstuurd",
        "scope_project": "{assignees} in dit project",
        "scope_units": "{units} × {assignees}",
        "title_placeholder": "Wat moet er gebeuren?",
        "units_selected": "{selected} van {count} unit geselecteerd | {selected} van {count} units geselecteerd",
        "units_title": "Welke units"
      },
      "labels": {
        "assignees_count": "{count} toegewezene | {count} toegewezenen",
        "created_by": "Aangemaakt door {name} · {date}",
        "created_on": "Aangemaakt op {date}",
        "required": "Dit veld is verplicht",
        "set_all_assignees": "Zet de toegewezene | Zet alle {count} toegewezenen",
        "still_to_do": "Nog {count} te doen",
        "tasks_count": "{count} taak | {count} taken",
        "units_count": "{count} unit | {count} units",
        "units_required": "Selecteer minstens één unit"
      },
      "toasts": {
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "remove_from_unit": "Taak uit deze unit verwijderd",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
